import type { ReviewCommentInterface, ReviewProductInterface } from 'modules/review/review.interface';

export enum ProductReviewStatus {
    hiddenByAdmin = 'hiddenByAdmin',
    negativeModeration = 'negativeModeration',
    notModerated = 'notModerated',
    positiveModeration = 'positiveModeration'
}

export interface ProductReviewInterface {
    id: number;
    author: string;
    product: ReviewProductInterface;
    content: string;
    rating: number;
    userComment?: ReviewCommentInterface[];
    createdAt: Date;
}

export enum ProductReviewSortingFields {
    creationDate = 'createdAt',
    rating = 'rating'
}

export interface ProductReviewAddCommentInterface {
    author: string;
    content: string;
    ip: string;
    productReviewId: number;
}
